export default __webpack_public_path__ + "static/heroSectionImg-f9f8d6373509f86d7b642264e3be4ac4.webp";